<template>
	<div v-if="isShowPage">
		<van-config-provider
			v-bind="vantThemeVars"
			:theme="theme"
			theme-vars-scope="global"
			class="min-h-screen w-full mx-auto"
			:class="isWhiteBg ? 'bg-white' : 'bg-[#EFEEEE]'"
		>
			<router-view></router-view>
		</van-config-provider>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import { allowMultipleToast } from "vant";
import { useGlobalStore } from "@/stores/modules/global";
import { vantThemeVars } from "@/config/vant";
import { WHITE_BG_ROUTE_NAME, REDIRECT_URL_TOKEN_KEY } from "@/config";
import { useFingerprint2 } from "@/hooks";
import { getLocalData, setLocalData } from "@/utils/storage";
import { formatStringToHex } from "@/utils/index";
import { useAuthStore } from "@/stores/modules/auth";

const route = useRoute();
const globalStore = useGlobalStore();
const authStore = useAuthStore();

const isShowPage = ref(false);
const { initFingerprint2 } = useFingerprint2();
const theme = computed(() => globalStore.themeGet);
const isWhiteBg = computed(() => WHITE_BG_ROUTE_NAME.includes(route.name as string));
initFingerprint2();
allowMultipleToast();

const searchParams = new URLSearchParams(window.location.search);
const token = searchParams.get("token") || getLocalData(REDIRECT_URL_TOKEN_KEY);

globalStore.setErrorCodes();

if (["deficonnect", "deficonnect-id"].includes(route.name as string)) {
	const { id = "" } = route.params;
	if (id) {
		const xTicket = (id as string)?.split("@@")?.[0] ?? "";
		authStore.setXTicket(xTicket);
	}
	isShowPage.value = true;
}

if (token) {
	setLocalData(REDIRECT_URL_TOKEN_KEY, token);
	isShowPage.value = true;
	globalStore.setWebsite();
	globalStore.setTrading();
	globalStore.setCustomerServices();
} else {
	globalStore.setWebsite().then((res: any) => {
		const redirectUrl = res?.row.redirectUrl;
		if (redirectUrl) {
			// 获取当前域名并转换为 hex
			const currentDomainHex = formatStringToHex(window.location.hostname);
			window.open(`${redirectUrl}?code=${currentDomainHex}`, "_self");
		} else {
			isShowPage.value = true;
		}
	});
}
</script>
